<h2 class="big-title" *ngIf="this.proj">{{ this.proj.title }}</h2>

<div class="big-title">חומרים שצריך לשלוח לספיריקל</div>
<div class="checkboxes" *ngIf="this.proj">
    <mat-checkbox  id="projName" [checked]="proj.materialschekList.projName"> שם של הפרויקט </mat-checkbox>
    <mat-checkbox  id="compName" [checked]="proj.materialschekList.compName"> שם של החברה </mat-checkbox>
    <mat-checkbox  id="compLogo" [checked]="proj.materialschekList.compLogo"> לוגו חברה </mat-checkbox>
    <mat-checkbox  id="projLogo" [checked]="proj.materialschekList.projLogo"> לוגו פרויקט </mat-checkbox>
    <mat-checkbox  id="renders" [checked]="proj.materialschekList.renders"> הדמיות </mat-checkbox>
    <mat-checkbox  id="renders360" [checked]="proj.materialschekList.renders360"> שתילות על גבי פנורמה </mat-checkbox>
    <mat-checkbox  id="plans" [checked]="proj.materialschekList.plans"> תוכניות </mat-checkbox>
    <mat-checkbox  id="projBook" [checked]="proj.materialschekList.projBook"> ספר פרויקט </mat-checkbox>
    <mat-checkbox  id="videoClip" [checked]="proj.materialschekList.videoClip"> סרטון </mat-checkbox>
    <mat-checkbox  id="appartmentsExel" [checked]="proj.materialschekList.appartmentsExel"> תרשים זרימה בפורמט אקסל </mat-checkbox>
</div>
